import React from "react";
import { LuHeartHandshake } from "react-icons/lu";
import { CiSquarePlus } from "react-icons/ci";
import { useLocation } from "react-router-dom";

function TitleHeader({ click, theme }) {
  const router = useLocation();
  return (
    <div
      className={`px-[2rem] py-[2rem] ${
        theme ? "bg-kdark3 text-[#888a8b]" : "bg-white text-[#27272E]"
      } flex justify-between w-full`}
    >
      <div className="flex gap-1 items-center">
        <LuHeartHandshake
          className={`w-[2rem]   h-[2rem] ${
            theme ? "text-[#888a8b]" : "text-[#FC5059]"
          }`}
        />
        <h4 className=" md:ml-[1rem]">Community</h4>
      </div>
      {(router?.pathname === "/dashboard/community/feeds" ||
        router?.pathname === "/dashboard/community/communities") && (
        <div
          onClick={click}
          className={`flex items-center border border-[1px] ${
            theme
              ? " text-[#888a8b]  border-[#888a8b]"
              : "border-[#02023414] text-[#27272E]"
          }  rounded-[6px] px-[.5rem]`}
        >
          <CiSquarePlus
            className={`w-[16px]  ${
              theme ? "text-[#888a8b]" : "text-[#000000]"
            }  h-[16px]`}
          />

          <button className="ml-[.2rem]">New community</button>
        </div>
      )}
    </div>
  );
}

export default TitleHeader;
